// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isEmpty = (val: any) => val == null || !(Object.keys(val) || val).length
